import './StateBox.module.scss';

import classNames from 'classnames';
import { MouseEventHandler } from 'react';

import { IVariant } from '@config/consts';
import { handleKeyDown } from '@utils/utils';

// todo: onclick from default props
export interface StateBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: IVariant;
  className?: string;
  hasHoverEffect?: boolean;
  onClick?: MouseEventHandler;
}

const StateBox: React.FC<StateBoxProps> = ({
  variant = 'default',
  hasHoverEffect = true,
  onClick,
  className,
  children,
  ...rest
}) => {
  // Handles keyboard interaction for Enter and Space keys
  if (variant === 'disabled') {
    return null;
  }
  return (
    <div
      className={classNames(`${className}--stateBox`, {
        'box--focused': variant === 'focus',
      })}
      data-zta="stateBox"
      {...rest}>
      <div
        onClick={onClick}
        onKeyDown={(e) => handleKeyDown(e, onClick)}
        role="button"
        aria-disabled={variant === 'error'}
        tabIndex={0}
        className={classNames(className, 'box', {
          'box-with--hover': hasHoverEffect,
          [`box--${variant}`]: variant !== 'focus',
        })}>
        {children}
      </div>
    </div>
  );
};

export default StateBox;
